import {
  UPDATE_TIMER,
} from '../actions/types';

const initialState = {
  minutesPre: 0,
  minutesLast: 0,
  secondsPre: 0,
  secondsLast: 0,
};

const timer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case UPDATE_TIMER:
      state = { ...state, ...payload };
      return state;
    default:
      return state;
  }
};

export default timer;



// WEBPACK FOOTER //
// ./src/reducers/timer.js